import styled, { css } from 'styled-components'

export function makeContainer(element) {
  return styled(element)`
    display: block;
    height: 100%;
    ${(props) =>
      props.textAlign &&
      css`
        text-align: ${props.textAlign};
      `}
    ${(props) =>
      props.width &&
      css`
        width: ${props.width};
      `}
    ${(props) =>
      props.maxWidth &&
      css`
        max-width: ${props.maxWidth};
      `}
    ${(props) =>
      props.marginTop &&
      css`
        margin-top: ${props.marginTop};
      `}
    ${(props) =>
      props.marginBottom &&
      css`
        margin-bottom: ${props.marginBottom};
      `}
  `
}

export default makeContainer('div')
